import type { EnvironmentMode } from './env-mode'

export type GoogleAnalyticsAppKey = 'CLIENTPORTAL' | 'GOKOLLAB'

/**
 * Production-active GA4 measurement IDs (legacy `clientportal-core/src/utils/const.ts`).
 *
 * | Key | ID | Where it runs |
 * |-----|-----|----------------|
 * | CLIENTPORTAL | G-91CZG6XDY5 | Client Portal shell (communities, courses MFA, etc.) — **logged-in only** |
 * | GOKOLLAB | G-C0S0S6XVMF | GoKollab app (including `/courses/*`) — **anonymous + logged-in** |
 * | GOKOLLAB_CP_STREAM | G-VWZEF00Q3B | Logged-in CP users on GoKollab (secondary stream) |
 */
export const GA_MEASUREMENT_IDS = {
  CLIENTPORTAL: 'G-91CZG6XDY5',
  GOKOLLAB: 'G-C0S0S6XVMF',
  GOKOLLAB_CP_STREAM: 'G-VWZEF00Q3B',
} as const

export interface GoogleAnalyticsEnvConfig {
  CLIENTPORTAL: string
  GOKOLLAB: string
  GOKOLLAB_CP_STREAM: string
}

/**
 * GA4 measurement IDs for production builds.
 * Local development logs events only; staging, interop, and production send via gtag.
 */
export function getGoogleAnalyticsConfig(_env: EnvironmentMode): GoogleAnalyticsEnvConfig {
  return {
    CLIENTPORTAL: GA_MEASUREMENT_IDS.CLIENTPORTAL,
    GOKOLLAB: GA_MEASUREMENT_IDS.GOKOLLAB,
    GOKOLLAB_CP_STREAM: GA_MEASUREMENT_IDS.GOKOLLAB_CP_STREAM,
  }
}
